import Phaser from 'phaser';
import { store } from '../stores/mainStore';
//import {DiceHand} from './DiceHand';
import {i18n} from '../i18n';

export class DicePopper{
	constructor(mng) { 
		this.m = mng; 
	}
	create() {
		this.popperBtnBkg = this.m.scene.add.image(0.5* this.m.config.width, 0.8* this.m.config.height, 'popper_button')
			.setScale(0.75).setDepth(3)
		const style = {fill: '#ffffff', font: '900 50px ' + this.m.ui.dodFontFamily};
		const x = this.popperBtnBkg.x, y = this.popperBtnBkg.y - 0.1*this.popperBtnBkg.height;
		this.popTxt = this.m.scene.add.text(x, y, i18n.t('skillz_pop_btn'), style)
			.setFontSize(100).setOrigin(0.5, 0.75).setDepth(3)
		this.popNumTxt = this.m.scene.add.text(x, y, 0, style).setFontSize(150).setOrigin(0.5, 0.05).setDepth(3)

		this.diceHand = this.m.diceHand;
		this.diceImages = this.diceHand.dice.map(d => d.diceImage);
		this.showLogoDice();

		this.hide();
	}

	show(buttonOnly = false){
		if(store.activeMatch && store.activeMatch.currentHand && store.activeMatch.currentHand.rollsRemaining)
			this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		if(buttonOnly)		this.showBtn(false)
		else 				this.showDices(false)
	}
	hide() {
		if(this.btnTween)	this.btnTween.stop(0);	
		if(this.diceTween)	this.diceTween.stop(0);
		this.btnEnable(false)
		this.popperBtnBkg.alpha = this.popTxt.alpha = this.popNumTxt.alpha = 0;
	}

	startRound() {
		this.showLogoDice();
		this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		this.showDices(true);
	}
	onClick() {
		this.btnEnable(false);
		this.popNumTxt.setText(~~this.popNumTxt.text -1)
		this.m.startThrow('popper');
		this.animation();
	}
	gotoNextRoll() {
		this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		this.showBtn(true);
	}

	animation() {
		const m = this.m, scene = this.m.scene, dh = this.m.diceHand;
		const getCoords = () => {
			const centerPos = dh.getDiceHomePosition(4);
			return Array.from(new Array(9), (v, i) => {
				const pos = dh.getDiceHomePosition(i), isCenter = i === 4, max = 1.3;
				const ang = Phaser.Math.Angle.BetweenPoints(centerPos, pos);
				const dist = isCenter ? m.diceActualWidth/3 : Phaser.Math.Distance.BetweenPoints(centerPos, pos);
				const addAng = ang + Phaser.Math.Angle.Random() * (isCenter ? 2 : 1/8);
				const coo = {
					x: centerPos.x + max*dist * Math.cos(addAng),
					y: centerPos.y + max*dist * Math.sin(addAng)
				}
				return coo;
			})
		}
		const roll3d = (timeline, targets, d, i) => {
			//d.diceImage.setTexture(store.custom.dice + '_dice3D_sheet', i * 9 + (++d.frameNum % 9))
			d.diceImage.setTexture('dice3D_sheet', i * 9 + (++d.frameNum % 9))
		}
		const backTo2d = (timeline, targets, d, i) => {
			this.showCardFace(d, i);
			targets[0].setScale(1);
		}

		//const t1 = 250, t2 = 125, t3 = 100, t4 = 150, t5 = 250;
		const t1 = 100, t2 = 100, t3 = 100, t4 = 100, t5 = 100;
		const enlarge = getCoords().map((coo, i) => {
			const d = dh.dice[i];
			return d.locked ? null : {
				targets: d.diceSprite, duration: t1, offset: 0,
				x: coo.x, y: coo.y, scale: 1.2,
				rotation: (Math.PI/4 + Phaser.Math.Angle.Random() /10) * (Math.random() < 0.5 ? 1 :  -1)
			}
		}).filter(Boolean)
		const drop = () => dh.dice.map((d, i) => {return d.locked ? null : {
			targets: d.diceSprite, duration: t2, offset: 0,
			x: dh.getDiceHomePosition(i).x, 
			y: dh.getDiceHomePosition(i).y, scale: 0.5,
			rotation: '*=' + (t1 + t2)/t1,
			onComplete: () => { d.frameNum = 0;}
		}}).filter(Boolean)
		const enlarge3d = getCoords().map((coo, i) => {
			const d = dh.dice[i];
			return d.locked ? null : {
				targets: d.diceSprite, duration: t3, offset: 0,
				x: coo.x, y: coo.y, scale: 2,
				onUpdate: roll3d, onUpdateParams: [d, i]
		}}).filter(Boolean)
		const rolling3d = dh.dice.map((d, i) => {
			return d.locked ? null :{
				targets: d.diceSprite, offset: 0,
				duration: 50, val: {from: 0, to: 1}, 
				onUpdate: roll3d, onUpdateParams: [d, i],
		}}).filter(Boolean)
		const stop3d = dh.dice.map((d, i) => {
			const time = Math.floor(t4 * Math.random())
			return d.locked ? null :{
				targets: d.diceSprite, offset: 0,
				duration: time, val: {from: 0, to: 1}, 
				onUpdate: roll3d, onUpdateParams: [d, i],
				onComplete: backTo2d, onCompleteParams: [d, i]
		}}).filter(Boolean)
		const shrink = dh.dice.map((d, i) => {return d.locked ? null : {
			targets: d.diceSprite, duration: t5, offset: 0,
			x: dh.getDiceHomePosition(i).x, 
			y: dh.getDiceHomePosition(i).y, 
			scale: 1, rotation: 0
		}}).filter(Boolean)

		scene.tweens.timeline({tweens: enlarge,
			onComplete: () => { scene.tweens.timeline({tweens: drop,
				onComplete: () => { scene.tweens.timeline({tweens: enlarge3d,
					onComplete: () => scene.tweens.timeline({
						tweens: rolling3d,
						loop: -1, onLoop: checkRollReceived
					})
				})}
			})}
		})

		const checkRollReceived = (timeline) => {
			if(store.activeMatch.currentHand.rolled) {
				timeline.stop();
				scene.tweens.timeline({tweens: stop3d,
					onComplete: () => { scene.tweens.timeline({tweens: shrink,
						onComplete: onAnimComplete
					})}
				})
			}
		}
		const onAnimComplete = () => {
			this.m.allDiceResolved();
		}
	}

	showLogoDice() {
		this.diceImages.forEach((di, i) => di.setTexture('logo_dice_sheet', i))
	}
	showCardDice() {
		this.diceHand.dice.forEach((d, i) => this.showCardFace(d, i))
	}
	showCardFace = (dice, i) => {
		dice.frameNum = -1;
		dice.currentFace = store.activeMatch.currentHand.dice[i].showing;
		//dice.diceImage.setTexture(store.custom.dice + '_dice2D_sheet', i * 6 + dice.currentFace);
		dice.diceImage.setTexture('dice2D_sheet', i * 6 + dice.currentFace);
	}

	btnEnable = par => {
		if(par) {		// enable btn
			try {
				this.popperBtnBkg.setInteractive({useHandCursor: true})
					.once('pointerup', () => this.onClick())
			} catch (err) {
				console.log('8120 ERROR on Popper', err)
			}
		} else {		// disable btn
			this.popperBtnBkg.disableInteractive().removeAllListeners();
		}
	}

	showDices = animated => {
		if(!store.activeMatch.currentHand.dice.some(d => d.showing))
			this.showLogoDice();
		this.diceHand.dice.forEach(d => {
			d.diceSprite.setX(d.homePosition.x).setY(d.homePosition.y).setScale(1)
			d.diceImage.setAlpha(0)
		});
		this.diceTween = this.m.scene.tweens.add({targets: this.diceImages,
			alpha: {from: 0, to: 1}, duration: !animated ? 0 : 200, 
			delay: (tar, key, v, i) => 50*i,
			onComplete: () => this.showBtn(animated)
		})
	}
	showBtn = animated => {
		this.btnTween = this.m.scene.tweens.add({duration: !animated ? 0 : 200,
			targets: [this.popperBtnBkg, this.popTxt, this.popNumTxt],
			alpha: {from: 0, to: 1}, 
			onComplete: () => this.btnEnable(true)
		})
	}
}